module.exports = __webpack_public_path__ + "src/assets/img/webanalytic.534a5f7d.jpg";